import { withStyles } from '@mui/styles';

import { PairApiConnectionForm } from './PairApiConnectionForm';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(PairApiConnectionForm);